export default [{
	path: 'stores',
	name: 'Stores',
	component: resolve => require(['@/views/Stores/index.vue'], resolve),
	meta: {
		title: '门店列表',
		name: 'Stores',
	}
},{
	path: 'store_info',
	name: 'StoreInfo',
	component: resolve => require(['@/views/StoreInfo/index.vue'], resolve),
	meta: {
		title: '门店详情',
		name: 'StoreInfo',
		isShow:true
	}
}]; 


// WEBPACK FOOTER //
// ./src/router/modules/stores.route.js